const Lapiceras = {
  lapicera: [
    {
      id: 1,
      path:"/productos-lapiceras",
      cover: "./images/lapiceras/1-lapicera.jpg",
      cover1:"./images/lapiceras/1-lapicera.jpg",
      cover2: "./images/lapiceras/1-lapicera.jpg",
      name: "Lapicera Azul",
      price: "L1",
      discount: 40,
    },
    {
      id: 2,
      path:"/productos-lapiceras",
      cover: "./images/lapiceras/1-lapicera.jpg",
      cover1:"./images/lapiceras/1-lapicera.jpg",
      cover2: "./images/lapiceras/1-lapicera.jpg",
      name: "Lapicera Verde",
      price: "L1",
      discount: 40,
    },
    {
      id: 3,
      path:"/productos-lapiceras",
      cover: "./images/lapiceras/1-lapicera.jpg",
      cover1:"./images/lapiceras/1-lapicera.jpg",
      cover2: "./images/lapiceras/1-lapicera.jpg",
      name: "Lapicera Negra",
      price: "L1",
      discount: 40,
    },
    {
      id: 4,
      path:"/productos-lapiceras",
      cover: "./images/lapiceras/1-lapicera.jpg",
      cover1:"./images/lapiceras/1-lapicera.jpg",
      cover2: "./images/lapiceras/1-lapicera.jpg",
      name: "Lapicera Roja",
      price: "L1",
      discount: 40,
    }
  ],
}
export default Lapiceras
